import React, { FC, ReactNode, useEffect, useState } from 'react';
import BaseHeader from './BaseHeader';
import BaseFooter from './BaseFooter';
interface BaseLayoutProps {
    children: ReactNode;
    showHeader?: boolean;
    showFooter?: boolean;
    containerClass?: string;
}
const BaseLayout: FC<BaseLayoutProps> = ({
    children,
    showHeader = true,
    showFooter = true,
    containerClass = 'lg:max-w-1200',
}) => {
    const [viewPortWidth, setViewPortWidth] = useState<number>();

    useEffect(() => {
        const windowHeight = () => {
            setViewPortWidth(window.innerHeight);
        };
        window.addEventListener('resize', windowHeight);
        windowHeight();
        return () => {
            window.removeEventListener('resize', windowHeight);
        };
    }, []);
    return (
        <div className={`flex flex-col h-screen`} style={{ maxHeight: viewPortWidth ? `${viewPortWidth}px` : 'auto' }}>
            {showHeader && <BaseHeader />}
            <div className="flex-auto overflow-y-auto flex justify-center bg-primary-10">
                <div className={`flex-auto flex flex-col relative max-w-full ${containerClass}`}>{children}</div>
            </div>
            {showFooter && <BaseFooter />}
        </div>
    );
};

export default BaseLayout;
